// removed by extract-text-webpack-plugin
module.exports = {"benefits":"n3_bx _3JIEYde9anI6O5H5wYv2ik","tick":"n3_n4","info":"n3_cb n3_n4","tooltip":"n3_jl"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/EventHeader/BookNow/Benefits/styles.module.css
// module id = 1287
// module chunks = 27